import {FontFaceProperties} from "@opendaw/lib-dom"

export const Fonts = {
    Rubik: <FontFaceProperties>{
        "font-family": "Rubik",
        "font-weight": 300,
        "font-style": "normal",
        "src": "/fonts/rubik.woff2"
    },
    OpenSans: <FontFaceProperties>{
        "font-family": "Open Sans",
        "font-weight": "normal",
        "font-style": "normal",
        "src": "/fonts/OpenSans-Regular.ttf"
    }
}